import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const ExpoChannelElementFields = {
  group: ELEMENT_GROUPS.TEXT,
  label: 'Expo Channel',
  icon: 'DocumentTextIcon',
  description:
    'Displays the current Expo release channel that the app is using',
  properties: [
    'layout',
    {
      label: 'Text',
      name: 'text',
      editor: 'textbox',
      description: 'The text to prepend to the field',
      default: 'Channel',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    'color',
    'font',
    'alignment',
    'margin',
    'padding'
  ]
};

export default ExpoChannelElementFields;
